<template>
    <div class="flex flex-col justify-between items-center max-w-[800px] w-full mx-auto mt-[80px] min-h-[422px] rounded-[3rem] border-[1px] border-[#d5ddf9] pt-[93px] text-center">
      <h2 class="text-[40px] leading-[24px] mb-[36px]">{{ $t('sdk.title') }}</h2>
      <p class="text-[24px] leading-[35px] max-w-[820px] mx-auto mb-[52px]">{{ $t('sdk.intro') }}</p>
      
      <div @click="clickCustomService" style="background: linear-gradient(138deg, #2e6062, #69a971);"
        class="flex justify-center items-center border-box mb-[30px] w-20 h-20 rounded-full hover:cursor-pointer transition-all duration-500 hover:scale-105 group">
        <i class="el-icon-microphone transition-all duration-300 group-hover:scale-[2] text-white" style="font-size: 28px;"></i>
      </div>

    </div>
</template>

<script>
import { getPackages } from '@/http/api/home'

export default {
  name: 'create-proxies',
  components: {
  },

  data() {
    return {
      
    }
  },
  inject: ['updateCurrentMenuUrl'],
  created() {
    this.updateCurrentMenuUrl('/ucenter/sdk/');
  },

  methods: {
    clickCustomService() {
      window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
  }
}

</script>

<style lang="scss">

</style>
